import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";

import moduleDrilling from "../store/moduleDrilling.js";

import { BooleanCell } from "../../shared/components";
import Datepicker from 'vuejs-datepicker';
import MovedByEnum from "../MovedByEnum";
import HoleActionsCellRenderer from "./components/holeActionsCellRenderer.vue";
import CoordinateSystemTypeEnum from "./../CoordinateSystemTypeEnum.js";

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    Datepicker,
    HoleActionsCellRenderer,
    BooleanCell
  },
  data() {
    return {
      includeInactiveHoles: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      holes: [],
      movedByValues: MovedByEnum.definition,
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.holeId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'holeId',
          width: 240,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(HoleActionsCellRenderer)
        },
        {
          headerName: this.$t('Drilling.Holes.Code'),
          field: "code",
          filter: true,
          width: 165
        },
        {
          headerName: this.$t('Drilling.HoleStatus.Name'),
          field: "status",
          filter: false,
          width: 165,
          valueGetter: (params) => {
            if (params.data.status !== undefined && params.data.status !== null) {
              return this.$t("Drilling.HoleStatus." + params.data.status);
            } else {
              return "";
            }
          }
        },
        {
          headerName: this.$t('Drilling.DrillHoleTypes.Name'),
          field: "drillHoleType",
          filter: false,
          width: 165,
          valueGetter: (params) => {
            if (params.data.drillHoleType !== undefined && params.data.drillHoleType !== null) {
              return this.$t("Drilling.DrillHoleTypes." + params.data.drillHoleType);
            } else {
              return "";
            }
          }
        },
        {
          headerName: this.$t('Drilling.RigTransportTypes.Name'),
          field: 'rigTransportType',
          filter: false,
          width: 165,
          valueGetter: (params) => {
            if (params.data.rigTransportType !== undefined && params.data.rigTransportType !== null) {
              return this.$t('Drilling.RigTransportTypes.' + params.data.rigTransportType);
            } else {
              return '';
            }
          }
        },
        {
          headerName: this.$t('Drilling.CoordinateSystemTypes.Name'),
          field: "coordinateSystemType",
          width: 200,
          filter: false,
          valueGetter: (params) => {
            if (params.data.coordinateSystemType !== undefined && params.data.coordinateSystemType !== CoordinateSystemTypeEnum.Unknown && params.data.coordinateSystemType !== null) {
              return this.$t("Drilling.CoordinateSystemTypes." + params.data.coordinateSystemType);
            } else {
              return "";
            }
          }
        },
        {
          headerName: this.$t('Drilling.Zones.SingleTitle'),
          field: "zoneName",
          width: 160,
          filter: false
        },
        {
          headerName: this.$t('Drilling.Holes.LatestTo'),
          field: "latestTo",
          filter: false,
          width: 100
        },
        {
          headerName: this.$t('Drilling.Holes.LatestToDate'),
          field: "latestToDate",
          filter: false,
          width: 165,
          valueGetter: (params) => {
            if (params.data.latestToDate !== undefined && params.data.latestToDate !== null) {
              return new Date(params.data.latestToDate).toLocaleDateString();
            } else {
              return "";
            }
          }
        },
        {
          headerName: this.$t('Drilling.Holes.IsEndOfHole'),
          field: "latestIsEndOfHole",
          filter: false,
          width: 145,
          cellRendererFramework: "BooleanCell"
        }
      ],
      components: {
        HoleActionsCellRenderer
      }
    };
  },
  computed: {
    companies() {
      return this.$store.state.drilling.companies;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }

    this.$vs.loading();
    this.$store.dispatch("drilling/fetchAllCompanies").then(() => {
      this.$refs.listCard.refreshcard();
    }).finally(() => {
      this.$vs.loading.close();
    })
  },
  watch: {
    includeInactiveHoles(newValue, oldValue) {
      this.getHoles();
    },
  },
  methods: {
    getHoles() {
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        this.$cqrsGet("Drilling/Holes/Search", { params: { mainProjectId: this.$store.state.projectId, includeInactiveHoles: this.includeInactiveHoles, nbPerPage:0 } })
          .then((response) => {
            this.holes = response.data.model;
            resolve(response)
          })
          .catch((error) => {
            errorHandler.loadingError(this._vm, error);
            reject(error)
          })
        .finally(() => {
          this.$vs.loading.close();
          this.$refs.listCard.removeRefreshAnimation()
        })
      });

    },
    setEndOfHole(holeId, isEndOfHole, notify) {
      return new Promise((resolve, reject) => {
        this.$cqrsPost("Drilling/Holes/SetIsEndOfHole", { holeId: holeId, isEndOfHole: isEndOfHole })
          .then((response) => {
            this.getHoles().then(() => {
              resolve(response);
            })
          })
          .catch((error) => {
            errorHandler.loadingError(this._vm, error);
            reject(error)
          })
          .finally(() => {
            this.$refs.listCard.removeRefreshAnimation()
            if (notify) this.$notifySaveSuccess();
          });
      });
    },
    setEndOfHoleOnSelectedRows() {
      const selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length === 0) {
        this.$vs.notify({
          title: this.$t("Drilling.Holes.NoSelection"),
          text: this.$t("Drilling.Holes.SelectHole"),
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-triangle"
        });
        return;
      }

      this.$vs.loading();
      const promises = selectedRows.map(row => {
        return this.setEndOfHole(row.holeId, true, false);
      });

      Promise.all(promises)
        .then(() => {
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("Drilling.Holes.EndOfHoleSet"),
            color: "success",
            iconPack: "feather",
            icon: "icon-check"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: this.$t("Error"),
            text: this.$t("Drilling.Holes.EndOfHoleNotSet"),
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-triangle"
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  }
};
